import React from 'react';
import { Form } from 'react-bootstrap';

const DenominationTable = ({
  denominations,
  handleDenominationChange,
  denominationTotal,
  isReadOnly,
  totalPayableAmount
}) => {
  return (
    <div className="foreclosure-card h-100">
      <h5 className="foreclosure-card-title">Cash Denomination</h5>
      
      <table className="foreclosure-table mb-3">
        <thead>
          <tr>
            <th style={{ width: '35%' }}>Denomination</th>
            <th style={{ width: '35%' }}>Count</th>
            <th style={{ width: '30%' }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(denominations)
            .sort(([a], [b]) => {
              if (a === "Coins") return 1;
              if (b === "Coins") return -1;
              return parseInt(b) - parseInt(a);
            })
            .map(([denom, count]) => (
              <tr key={denom}>
                <td className="fw-semibold text-center">{denom}</td>
                <td className="text-center">
                  <Form.Control
                    type="number"
                    value={count}
                    onChange={(e) => handleDenominationChange(denom, e.target.value)}
                    min="0"
                    readOnly={isReadOnly}
                    style={{ maxWidth: "85px", margin: "0 auto", textAlign: "center", height: "30px", fontSize: "0.85rem" }}
                    onKeyDown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }
                      if (
                        e.key === "-" ||
                        e.key === "+" ||
                        e.key === "e" ||
                        e.key === "E"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => e.preventDefault()}
                    onFocus={(e) => {
                      e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false });
                    }}
                    onBlur={(e) => {
                      e.target.removeEventListener("wheel", (e) => e.preventDefault());
                    }}
                  />
                </td>
                <td className="text-center fw-bold">
                  ₹{denom === "Coins" ? count : parseInt(denom) * count}
                </td>
              </tr>
            ))}
          <tr style={{ backgroundColor: "#F0FDF4", fontWeight: "bold" }}>
            <td colSpan="2" className="text-start ps-3" style={{ color: "#166534" }}>Collected Cash</td>
            <td className="text-center" style={{ color: "#166534", fontSize: '0.95rem' }}>₹{denominationTotal}</td>
          </tr>
          {totalPayableAmount > 0 && denominationTotal < totalPayableAmount && (
            <tr style={{ backgroundColor: "#FEF2F2", fontWeight: "bold" }}>
              <td colSpan="2" className="text-start ps-3" style={{ color: "#991B1B" }}>Waiver / Discount</td>
              <td className="text-center" style={{ color: "#991B1B", fontSize: '0.95rem' }}>
                ₹{totalPayableAmount - denominationTotal}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DenominationTable;